import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../lib/auth.ts";

interface Props {
  children: React.ReactNode;
}

export default function AuthGuard({ children }: Props) {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    // Small delay to let auth state settle on mount
    setOk(isAuthenticated());
    setChecking(false);
  }, []);

  if (checking) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <p className="text-gray-400 text-sm">Loading…</p>
      </div>
    );
  }

  if (!ok) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}